import { Component, Input } from '@angular/core';
import { TranslatableKey } from '@app/types/translatable.type';
import { GoalMetricsDisplayOptions } from '@app/types/translatables/goal-metrics-display.options';
import { BaseForm } from '@forms/base.form';
import { Goal } from '@models/performance/goal.model';

@Component({
    selector: 'app-form-goal-summary',
    templateUrl: './goal-summary.template.html',
})
export class GoalSummaryForm extends BaseForm {
    @Input() goal: Goal;
    @Input() participants: Map<number, boolean>;

    getGoalMetricTranslatable(): TranslatableKey | string {
        return GoalMetricsDisplayOptions[this.goal.metricType] ?? this.goal.metricType;
    }

    getParticipantCount(): number {
        return Array.from(this.participants).filter(([_, selected]) => selected).length;
    }
}
